import * as Sentry from '@sentry/sveltekit';
import { config } from '$lib/config';
import { sanitizeSentryEvent, sanitizeSentryLog } from '$lib/services/sentry/sanitize';

// Solo client-side: este proyecto usa adapter-static, no hay servidor donde correr Sentry
Sentry.init({
  dsn: config.sentry.dsn,
  environment: config.sentry.environment,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()], // performance + session replay
  debug: import.meta.env.DEV, // en dev, logea en consola lo que el SDK está capturando/enviando
  tracesSampleRate: config.sentry.tracesSampleRate,
  replaysSessionSampleRate: config.sentry.replaysSessionSampleRate,
  replaysOnErrorSampleRate: config.sentry.replaysOnErrorSampleRate,
  sendDefaultPii: true, // habilita IP/user-agent en eventos; la sanitización de abajo es la segunda línea de defensa
  enableLogs: true, // habilita Sentry.logger.* para tracing estructurado sin crear Issues
  beforeSend: (event) => sanitizeSentryEvent(event),
  beforeSendLog: (log) => sanitizeSentryLog(log)
});

// Reporta a Sentry los errores no capturados de navegación/renderizado de SvelteKit
export const handleError = Sentry.handleErrorWithSentry();
